module.exports = __webpack_public_path__ + "static/media/AE-VC.8a22aca2.gif";